import produce from 'immer'
import { Reducer } from 'redux'
import { BackofficeActions, BackofficeState } from './types'

const initialState: BackofficeState = {
  data: {
    items: [],
    total: 0
  },
  currentPage: 1,
  skip: 0,
  take: 5
}

export const Backoffice: Reducer<BackofficeState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case BackofficeActions.GET_BACKOFFICE_SUCCESS:
      return produce(state, (draftState) => {
        draftState.data = action.payload.data
        draftState.skip = action.payload.skip
        draftState.currentPage = action.payload.currentPage
      })
    case BackofficeActions.CREATE_BACKOFFICE_SUCCESS:
      return produce(state, (draftState) => {
        draftState.data.items.push(action.payload)
      })
    case BackofficeActions.EDIT_BACKOFFICE_SUCCESS:
      return produce(state, (draftState) => {
        const index = draftState.data.items.findIndex(
          (i) => i.id === action.payload.id
        )
        if (index > -1) {
          draftState.data.items[index] = action.payload
        }
      })
    case BackofficeActions.DELETE_BACKOFFICE_SUCCESS:
      return produce(state, (draftState) => {
        action.payload.forEach((backofficeId: string) => {
          const index = draftState.data.items.findIndex(
            (backoffice) => backoffice.id === backofficeId
          )

          if (index > -1) {
            draftState.data.items.splice(index, 1)
          }
        })
      })
    default:
      return state
  }
}
